import React, { useState, useEffect } from "react";
import { ChevronLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import apilink from "../apiURL/baseUrls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const MoreHistory = () => {
  const navigate = useNavigate();
  const [gatherings, setGatherings] = React.useState([]);
  const [postinginfo, setPostinginfo] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [info, setInfo] = useState({
    familycode: "",
    id: "",
    notes: "",
  });

  const [updating, setUpdating] = useState(false);

  const editRecord = async (id) => {
    let result = gatherings.find((obj) => obj.id == id);

    setInfo({
      ...info,
      id: result.id,
      notes: result.notes,
    });

    setUpdating(true);
  };

  const refetchData = async () => {
    const storedUser = await JSON.parse(
      localStorage.getItem("userSessionData")
    );

    setPostinginfo(false);
    setUpdating(false);
    setDeleting(false);

    setInfo({
      ...info,
      familycode: storedUser.familycode,
      id: "",
      notes: "",
    });

    //Today
    const baseUrl = apilink.link;
    await axios
      .get(`${baseUrl}/family/admin/history/${storedUser.familycode}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })

      .then((response) => {
        if (response.data.message == "Successfull") {
          setGatherings(response.data.records);
        }
      })
      .catch((error) => {
        console.log(error.response.data.message);
      });
  };

  const handleDelete = async () => {
    if (info.id === "") {
      toast.warn("Failed. Select record first", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    setDeleting(true);

    const baseUrl = apilink.link;

    console.log(info);
    axios
      .get(`${baseUrl}/family/admin/deletehistory/${info.id}`, info)
      .then((response) => {
        if (response.data.message == "Saving successfull") {
          toast.success("Deletion successfull", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          refetchData();
          return;
        } else {
          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setDeleting(false);
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("Error creating fetching", err);
      });
  };
  const handleInfo = async () => {
    if (gatherings.length > 0 && info.id === "") {
        toast.warn("Failed. Click the family history record first to load it before updating", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
      }
    if (info.notes === "") {
      toast.warn("Failed. Fill in the family history", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setPostinginfo(true);

    const baseUrl = apilink.link;

    let url = "history";
    if (updating) {
      url = "updatehistory";
    }

    if (gatherings.length > 0) {
        setUpdating(true);
        url = "updatehistory";
    }

    console.log(info);
    axios
      .post(`${baseUrl}/family/admin/${url}`, info)
      .then((response) => {
        if (response.data.message == "Saving successfull") {
          toast.success("Saving successfull", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          refetchData();
          return;
        } else {
          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setPostinginfo(false);
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("Error creating post");
      });
  };

  useEffect(() => {
    const getAsyncData = async () => {
      const storedUser = await JSON.parse(
        localStorage.getItem("userSessionData")
      );

      setInfo({familycode: storedUser.familycode, id: "",
      notes: "" });

      //Today
      const baseUrl = apilink.link;
      await axios
        .get(`${baseUrl}/family/admin/history/${storedUser.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          if (response.data.message == "Successfull") {
            setGatherings(response.data.records);
          }
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    };
    getAsyncData();
  }, []);
  return (
    <div>
      <div
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#EA6C82",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <h4 onClick={()=>navigate("/admin/more")} style={{ fontFamily: "Open Sans", fontSize: 17 }}>
          <ChevronLeft size={20} style={{ color: "#ffffff" }} />
        </h4>
        <h4 style={{ fontFamily: "Open Sans", fontSize: 17, color: "#ffffff" }}>
          <b>More /</b> History
        </h4>
      </div>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <div
          style={{
            alignItems: "center",
            paddingInline: "10px",
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#EA6C8220",
            height: "50px",
            marginBottom: "40px",
            width: "100%",
            borderRadius: "5px",
          }}
        >
          <h4
            style={{ fontFamily: "Open Sans", fontSize: 20, color: "#EA6C82" }}
          >
            History Form - {updating ? "Update" : "Save"}
          </h4>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <label style={{ fontFamily: "Open Sans", fontSize: 12 }}>
              Family History
            </label>
            <br />
            <textarea
              style={{
                width: "100%",
                height: "125px",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginBottom: "10px",
              }}
              value={info.notes}
              onChange={(e) => {
                setInfo({ ...info, notes: e.target.value });
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-9"></div>

          <div className="col-lg-3">
            <button
              onClick={() => handleInfo()}
              style={{
                width: "100%",
                backgroundColor: "#EA6C82",
                borderRadius: 5,
                border: "none",
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                marginTop: 23,
                color: "white",
              }}
            >
              {postinginfo === false && (
               <>
               {updating && gatherings.length > 0
                 ? "Update"
                 : gatherings.length > 0
                 ? "Update"
                 : "Save"}
               </>
            
              )}
              {postinginfo && (
                <>
                  <Squares />
                </>
              )}
            </button>

            {updating && (
              <div className="row">
                <div className="col-lg-6">
                  <button
                    onClick={() => refetchData()}
                    style={{
                      width: "100%",
                      backgroundColor: "orange",
                      borderRadius: 5,
                      border: "none",
                      height: 50,
                      fontFamily: "Open Sans",
                      fontSize: 14,
                      marginTop: 23,
                      color: "white",
                    }}
                  >
                    Clear
                  </button>
                </div>
                <div className="col-lg-6">
                  <button
                    onClick={() => handleDelete()}
                    style={{
                      width: "100%",
                      backgroundColor: "red",
                      borderRadius: 5,
                      border: "none",
                      height: 50,
                      fontFamily: "Open Sans",
                      fontSize: 14,
                      marginTop: 23,
                      color: "white",
                    }}
                  >
                    {deleting === false && <> {"Delete"}</>}
                    {deleting && (
                      <>
                        <Squares />
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Close Birthdays*/}
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "17px",
        }}
      >
        <div
          style={{
            alignItems: "center",
            paddingInline: "10px",
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#EA6C8220",
            height: "50px",
            marginBottom: "40px",
            width: "100%",
            borderRadius: "5px",
          }}
        >
          <h4
            style={{ fontFamily: "Open Sans", fontSize: 20, color: "#EA6C82" }}
          >
            Saved Gatherings ({gatherings.length})
          </h4>
          <br></br>
          <label style={{ color: "red" }}>
            Click the record information to get edit or delete options
          </label>
        </div>
        {gatherings.map((record) => (
          <div
            key={record.id}
            onClick={() => editRecord(record.id)}
            style={{ flexDirection: "column", marginBottom: "30px" }}
          >
            <h6 style={{ fontFamily: "Open Sans", fontWeight: "bold" }}>
              {record.notes}
            </h6>
          </div>
        ))}
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default MoreHistory;
